module.exports = __webpack_public_path__ + "img/step6.e8c4c72c.png";